export default "__VITE_ASSET__on0hVF3P__";